module.exports = __webpack_public_path__ + "img/shear.7f232c49.png";